<template>
    <div :style="spinnerStyle" class="spinner">
        <div :style="dotStyle" class="bounce1"></div>
        <div :style="dotStyle" class="bounce2"></div>
        <div :style="dotStyle" class="bounce3"></div>
    </div> 
</template>

<script>
export default {
    name: 'Spinner',
    props: {
        color: {
            default: 'mix'
        },
        size: {
            default: '12px'
        }
    },
    computed: {
        spinnerStyle() {
            if (this.color == 'mix') {
                return {
                    mixBlendMode: 'difference'
                }
            }
            else {
                return {}
            }
        },
        dotStyle() {
            var bgcolor
            if (this.color == 'mix') {
                bgcolor = 'white'
            }
            else {
                bgcolor = this.color
            }
            return {
                backgroundColor: bgcolor,
                width: this.size,
                height: this.size,
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.spinner {
    margin: 0 auto 0;
    text-align: center;
}

.spinner > div {
    width: 12px;
    height: 12px;

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}

.spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0) }
    40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
    0%, 80%, 100% { 
        -webkit-transform: scale(0);
        transform: scale(0);
    } 40% { 
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
    }
}
</style>